import React, {Component} from 'react';
import {Button, Container, Grid, Header, Icon, Input, Table} from "semantic-ui-react";
import {NavLink} from "react-router-dom";
import StaticText from "../components/StaticText";

export default class FAQPage extends Component {
    render() {

        return (
            <div className="page-container white">

                <div className="about-header">
                    <div className="line-background">
                        <div className="line"/>
                        <Container>
                            <Grid>
                                <Grid.Row>
                                </Grid.Row>
                            </Grid>
                        </Container>
                    </div>
                </div>

                <Container>

                    <Grid>
                        <Grid.Row>
                            <Grid.Column fluid>
                                <Button as={NavLink} to="/" style={{float: "left"}} icon labelPosition="left">
                                    <Icon name="left arrow"/>
                                    Back
                                </Button><br/>
                                <h1 style={{paddingLeft: "10px"}}>
                                    Frequently Asked Questions Sailscanner
                                </h1>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>

                    <Grid stackable className="gt-card">
                        <Grid.Row centered>
                            <Grid.Column>
                                <StaticText label={"faq"}/>
                            </Grid.Column>
                        </Grid.Row>

                    </Grid>

                    <Grid>
                        <Grid.Row>
                            <Grid.Column fluid>
                                <div style={{height: "100px"}}/>
                                <Button as={NavLink} to="/" icon labelPosition="left">
                                    <Icon name="left arrow"/>
                                    Back
                                </Button>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>

                </Container>


            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/faq.js